import HBIcon from "@/components/HBIcon";
import { Dropdown } from "antd";
import classNames from "classnames";
import { useCallback, useMemo } from "react";
import { Else, If, Then, When } from "react-if";
import styles from "./index.module.less";

/**
 *  @param {*} props

 */

export default function FilterSelect({
  className = "",
  value = null,
  name = "",
  icon = "",
  iconType = "iconfont", // iconfont文字、img图片
  optionType = "text", // text文字、img图片
  optionKey = "value",
  allowClear = true,
  options = [],
  placement = "bottomLeft",
  trigger = "click",
  onChange = null,
  disabled,
  customprops = {},
  getPopupContainer = null,
  getOptionExtData = null, // 获取每个 option 的额外埋点数据
}) {
  const onOptionClick = useCallback(
    (option) => () => {
      onChange && onChange(option);
    },
    [onChange]
  );

  const onClose = useCallback(
    (evt) => {
      evt.stopPropagation();
      onChange && onChange(null);
    },
    [onChange]
  );

  const menu = useMemo(() => {
    return (
      <div className={styles.container}>
        <If condition={optionType === "text"}>
          <Then>
            <div className={styles.list}>
              <div className={styles.wrapper}>
                {options.map((option) => {
                  const extData = getOptionExtData
                    ? getOptionExtData(option.value)
                    : null;
                  return (
                    <div
                      key={option[optionKey]}
                      className={classNames([
                        styles.item,
                        option.value === value?.value ? styles.active : null,
                      ])}
                      onClick={onOptionClick(option)}
                      data-gd-click="button_click"
                      data-button-name={`筛选项${name ? `-${name}` : ""}-${
                        option.label
                      }`}
                      {...(extData
                        ? { "data-ext": JSON.stringify(extData) }
                        : {})}
                    >
                      <When condition={option.icon}>
                        <div className={styles.icon}>
                          <If condition={iconType === "iconfont"}>
                            <Then>
                              <HBIcon
                                className={styles.iconfont}
                                type={option.icon}
                              />
                            </Then>
                            <Else>
                              <img src={option.icon} alt={options.label} />
                            </Else>
                          </If>
                        </div>
                      </When>
                      <div className={styles.text}>
                        {option.optionLabel || option.label}
                      </div>
                      <div className={styles.checked}>
                        <HBIcon type="ic_check" />
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </Then>
          <Else>
            <div className={styles.imgs}>
              {options.map((option) => {
                const extData = getOptionExtData
                  ? getOptionExtData(option.value)
                  : null;
                return (
                  <div
                    className={styles.img}
                    key={option[optionKey]}
                    onClick={onOptionClick(option)}
                    data-gd-click="button_click"
                    data-button-name={`筛选项${name ? `-${name}` : ""}-${
                      option.label
                    }`}
                    {...(extData
                      ? { "data-ext": JSON.stringify(extData) }
                      : {})}
                  >
                    <img src={option.icon} alt={option.label} />
                  </div>
                );
              })}
            </div>
          </Else>
        </If>
      </div>
    );
  }, [optionType, options, optionKey, value, onOptionClick, name, iconType]);

  return (
    <Dropdown
      overlay={menu}
      placement={placement}
      trigger={trigger}
      getPopupContainer={
        getPopupContainer || ((triggerNode) => triggerNode.parentNode)
      }
      disabled={disabled}
      {...customprops}
    >
      <div
        className={classNames([
          styles.select,
          value && allowClear ? styles.active : null,
          disabled ? styles.disabled : null,
          className,
        ])}
      >
        {/* 图标 */}
        <If condition={iconType === "img"}>
          <Then>
            <When condition={value?.icon || icon}>
              <div className={styles.icon}>
                <img
                  src={value?.icon || icon}
                  alt={value?.label || "筛选器图标"}
                />
              </div>
            </When>
          </Then>
          <Else>
            <When condition={value?.icon || icon}>
              <div className={styles.icon}>
                <HBIcon
                  className={styles.iconfont}
                  type={value?.icon || icon}
                />
              </div>
            </When>
          </Else>
        </If>

        {/* 文字 */}
        <div className={styles.text}>{value?.label || name}</div>

        {/* 箭头 */}
        <div className={styles.arrow}></div>

        {/* 清空 icon */}
        <HBIcon
          className={styles.close}
          type="ic_clear"
          onClick={onClose}
          data-gd-click="button_click"
          data-button-name={`筛选项-${name}-清空`}
        />
      </div>
    </Dropdown>
  );
}
